// This is required by the webpack config so must export using commonjs syntax
module.exports = Object.freeze({
  IFX_COMPOSER_SEND_TO_PRINT_EVENT: 'composer:send_to_print',
  TRIDENT_ROUTE_COMPOSER_UI: process.env.ROUTE_BASE_PATH,
  TRIDENT_ROUTE_COMPOSER_API: `${process.env.ROUTE_BASE_PATH}/api`,
  TRIDENT_ROUTE_IFX_INVOKE_API: '/ifx/api/v1/admin/invoke',
  SENTRY_DSN:
    'https://ff967c1fc6764595be591ca835e18b09@pharos.arcpublishing.com/19',
})
